import useRedirectUrl from "@casino/legacy/client/components/Auth/hooks/useRedirectUrl";
import getCsrfToken from "@casino/legacy/client/features/SocialAuth/csrf/getCsrfToken";
import useSocialAuthConf from "@casino/legacy/client/features/SocialAuth/hooks/useSocialAuthConf";
import useFeature from "@casino/legacy/client/hooks/feature/useFeature";
import useRouter from "@casino/legacy/client/hooks/router/useRouter";
import useAppContext from "@casino/legacy/shared/context/AppContext/useAppContext";
import getEnv from "@casino/legacy/shared/utils/getEnv";
import { setCookie } from "@workspace/cookies/browser";
import { useCallback } from "react";

const useAuth0CallbackUri = () => {
  const { pathPrefix } = useAppContext();
  return `${global.location?.origin}${pathPrefix}/callback`;
};

const useAuth0ConnectionClicked = () => {
  const { pathname, asPath } = useRouter();
  const redirectPath = useRedirectUrl();
  const redirect = redirectPath === "" ? asPath : redirectPath;
  const redirectURL = useAuth0CallbackUri();
  const isAuth88CallbackEnabled = useFeature("isAuth88CallbackEnabled");
  const auth0RedirectUri = isAuth88CallbackEnabled
    ? (getEnv("SOCIAL_AUTH_CALLBACK_URL") ?? "https://auth88.io/auth-callback")
    : redirectURL;
  const { auth0Config } = useSocialAuthConf();

  const handleClick = useCallback(
    (connection: Connection) => {
      if (auth0Config) {
        const { domain, clientId } = auth0Config;
        const state = btoa(
          JSON.stringify({
            connection,
            redirect,
            csrf: getCsrfToken(),
            redirectURL,
          }),
        );
        const auth0Uri = `https://${domain}/authorize?client_id=${clientId}&connection=${connection}&redirect_uri=${auth0RedirectUri}&response_type=token&scope=openid%20profile%20email&auth0Client=eyJuYW1lIjoiYXV0aDAuanMiLCJ2ZXJzaW9uIjoiOS4xOS4wIn0%&state=${state}`;
        location.assign(auth0Uri);
      }
      sessionStorage.setItem("social_auth_path", pathname);
      setCookie("social_auth_type", connection);
    },
    [auth0Config, pathname, redirect, redirectURL, auth0RedirectUri],
  );
  return handleClick;
};

export default useAuth0ConnectionClicked;
